import React from 'react';
import { bem, use } from '../../lib';
export const ModalBody = ({ children, padded, noDivider }) => (React.createElement("div", { className: bem('modal__body', use(padded, '--padded')) },
    !noDivider && React.createElement("hr", { className: "hr--light" }),
    React.createElement("div", { className: "modal__body-content" }, children)));
//# sourceMappingURL=ModalBody.js.map